<template>
  <div class="page">
    <!-- 搜索栏行 -->
    <div class="searchRow">
      <!-- 企业名称 -->
      <div class="left">
        <img
          v-if="depConfig.channelLogoSrc"
          :src="depConfig.channelLogoSrc"
          alt=""
        />
        <span v-else :style="getDepTitleStyle(depConfig.depTitle)">{{
          depConfig.depTitle
        }}</span>
      </div>
      <!-- 搜索栏行 -->
      <div class="center" @click="toPage('searchProduct')">
        <img
          src="https://static.xchengtech.cn/f77446d710ef4e588eccd1ad188ccdd2.png"
          alt=""
        /><span>搜索产品</span>
      </div>
      <!-- 用户头像和办理指引 -->
      <div class="right">
        <!-- 办理指引 -->
        <img
          @click="toPage('operatingManual')"
          src="https://static.xchengtech.cn/08663d858d7e461b9da530c91bd587b1.png"
          alt=""
        />
        <!-- 普通租户才有微信客服 -->
        <div v-if="!depConfig.bizType">
          <!-- 微信客服 -->
          <img
            @click="toPage('customerService')"
            src="https://static.xchengtech.cn/04b6375d76f24d5186016ed22bc05040.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 大标题行 -->
    <div class="bigTitleRow" :class="getTitleStyle(depConfig.bizType)">
      <div>
        {{
          depConfig.topBlockUpTitle
            ? depConfig.topBlockUpTitle
            : "企业数智服务中心"
        }}
      </div>
      <div v-show="depConfig.topBlockTitle">
        {{ depConfig.topBlockTitle }}
      </div>
      <div v-show="depConfig.topBlockTitleSub">
        {{ depConfig.topBlockTitleSub }}
      </div>
    </div>

    <!-- 小标题行 -->
    <div
      class="smallTitleRow"
      v-show="depConfig.bizType == 'csqfpt' || depConfig.bizType == 'ssh'"
    >
      <div @click="toUrl(depConfig.topBlockModuleALink)">
        <span
          :style="
            depConfig.themeColor
              ? {
                  color: depConfig.themeColor,
                  borderColor: depConfig.themeColor,
                }
              : ''
          "
          >{{
            depConfig.topBlockModuleATitle
              ? depConfig.topBlockModuleATitle
              : "集中管理客户"
          }}</span
        ><span>{{
          depConfig.topBlockModuleADesc
            ? depConfig.topBlockModuleADesc
            : "整合基础资料、交易记录、业务偏好"
        }}</span>
      </div>
      <div @click="toUrl(depConfig.topBlockModuleBLink)">
        <span
          :style="
            depConfig.themeColor
              ? {
                  color: depConfig.themeColor,
                  borderColor: depConfig.themeColor,
                }
              : ''
          "
          >{{
            depConfig.topBlockModuleBTitle
              ? depConfig.topBlockModuleBTitle
              : "精准拓展客户"
          }}</span
        ><span>{{
          depConfig.topBlockModuleBDesc
            ? depConfig.topBlockModuleBDesc
            : "大数据挖掘潜在客群，生成营销名单"
        }}</span>
      </div>
      <div @click="toUrl(depConfig.topBlockModuleCLink)">
        <span
          :style="
            depConfig.themeColor
              ? {
                  color: depConfig.themeColor,
                  borderColor: depConfig.themeColor,
                }
              : ''
          "
          >{{
            depConfig.topBlockModuleCTitle
              ? depConfig.topBlockModuleCTitle
              : "智能客户服务"
          }}</span
        ><span>{{
          depConfig.topBlockModuleCDesc
            ? depConfig.topBlockModuleCDesc
            : "识别客户需求，个性化服务推荐"
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth.js";
import { getDepNameByDomain } from "@/utils/index";
import { getCurrentChannelInfo } from "@/api/login.js";
import { xcDepConfig } from "@/api/depConfig.js";
export default {
  props: {
    depConfig: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},

  computed: {
    getDepTitleStyle() {
      return function (name) {
        if (name && name.length <= 6) {
          return { "white-space": "nowrap" };
        } else {
          return { width: "20vw" };
        }
      };
    },
    getTitleStyle() {
      return function (bizType) {
        if (bizType === "ssh" || bizType === "csqfpt") {
          return "sshModelTitle";
        }
      };
    },
  },
  methods: {
    toPage(name) {
      console.log("name", name);
      switch (name) {
        case "none":
          Toast.success("功能暂未开放，敬请期待");
          break;
        case "customerService":
          let url = "https://work.weixin.qq.com/kfid/kfc1cdc298d63eca9ed";
          window.open(url);
          break;
        default:
          this.$router.push({ path: "/" + name });
          break;
      }
    },
    toUrl(url) {
      console.log("utl", url);
      if (url) {
        window.location.href = url;
      }
    },
    getChannelInfo() {
      // 渠道已登录的时候才获取渠道信息
      if (getToken()) {
        // 获取渠道信息
        getCurrentChannelInfo()
          .then((res) => {
            this.channelInfo = res;
          })
          .catch((err) => {
            console.log("err", err);
            Toast.clear();
          });
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding: 4vw 4vw 0 4vw;
}
.searchRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4vw;
}
.searchRow .left {
  /* width: 44vw; */
}

.searchRow .left img {
  display: block;
  height: 9vw;
}
.searchRow .left span {
  display: block;
  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
  color: white;
  font-weight: 600;
  font-size: 4vw;
  /* min-width: 30vw; */
}

.searchRow .center {
  padding: 2vw 3vw;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: white;
  border-radius: 6px;
  gap: 2vw;
  color: #bfbfbf;
  border-radius: 35px;
}
.searchRow .center img {
  display: block;
  height: 3vw;
}

.searchRow .right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4vw;
}

.searchRow .right img {
  display: block;
  height: 7vw;
}
.searchRow .right .headImgUrl {
  display: block;
  border-radius: 35px;
}
.searchRow .right span {
  white-space: nowrap;
  color: white;
}

.bigTitleRow {
  padding: 7vw 2vw 0 2vw;
}

.bigTitleRow div:nth-of-type(1),
.bigTitleRow div:nth-of-type(2) {
  text-align: center;
  color: white;
  font-weight: 600;
  font-size: 9vw;
}

.bigTitleRow div:nth-of-type(3) {
  padding-top: 1vw;
  display: flex;
  align-items: center;
  gap: 1vw;
  justify-content: center;
  color: white;
  text-align: center;
  /* color: #eee0c2; */
}

.smallTitleRow {
  padding-top: 5vw;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4vw;
  text-align: center;
}

.smallTitleRow div span:nth-of-type(1) {
  display: block;
  padding: 1vw;
  background-color: white;
  color: #2841c1;
  font-weight: 600;
  border-radius: 35px;
}

.smallTitleRow div span:nth-of-type(2) {
  display: block;
  padding-top: 2vw;
  color: white;
  font-size: 3.2vw;
}
/* 协会模式标题样式 */
.sshModelTitle {
  font-size: 6vw !important;
}
.sshModelTitle div:nth-of-type(1) {
  font-size: 7vw;
  padding-bottom: 2vw;
}
.sshModelTitle div:nth-of-type(2) {
  font-size: 6vw;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/module/headerDiv.vue